export default __webpack_public_path__ + "static/media/bg1.d12d8ad1.jpg";